<script>
	// Stores
	import { linkBoletoFacil } from '../store.js';
	function close(){
		document.querySelector('.boletoFacil').style.display = 'none';
	}
</script>

<span class="boletoFacil" style="position: fixed; left: 5px; z-index: 100; bottom: 5px; display: inline-block;">
	<a href="{$linkBoletoFacil}" target="_blank" title="Boleto fácil">
		<img src="assets/images/imgBoleto.png" alt="Boleto" style="border: 0px;" />
	</a>
	<button on:click={close} title="Fechar">x</button>
</span>

<style type="text/sass">
button
	background-color: #FFF
	border: 1px solid #000
	position: absolute
	right: 0px
	top: 0px
	width: 25px
	height: 25px
	font-size: 15px
	border-radius: 50%
	font-weight: bold
	cursor: pointer
</style>